import { render, staticRenderFns } from "./SupplierProductsAdd.vue?vue&type=template&id=ce40efc0&scoped=true&"
import script from "./SupplierProductsAdd.vue?vue&type=script&lang=js&"
export * from "./SupplierProductsAdd.vue?vue&type=script&lang=js&"
import style0 from "./SupplierProductsAdd.vue?vue&type=style&index=0&id=ce40efc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce40efc0",
  null
  
)

export default component.exports